import React, { useState, useEffect } from 'react';

const AnnouncementModal = ({ onClose }) => {
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    fetchCurrentAnnouncement();
  }, []);

  const fetchCurrentAnnouncement = async () => {
    try {
      const response = await fetch('/announcements/current', {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        credentials: 'same-origin'
      });

      const data = await response.json();
      
      if (data.show_announcement) {
        setAnnouncement(data.announcement);
        setVisible(true);
      } else {
        // No announcement to show
        if (onClose) onClose();
      }
    } catch (error) {
      console.error('Error fetching announcement:', error);
      if (onClose) onClose();
    } finally {
      setLoading(false);
    }
  };

  const handleAcknowledge = async () => {
    if (!announcement) return;

    try {
      await fetch(`/announcements/${announcement.id}/acknowledge`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        credentials: 'same-origin'
      });

      handleClose();
    } catch (error) {
      console.error('Error acknowledging announcement:', error);
      handleClose();
    }
  };

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  };

  if (loading || !announcement) {
    return null;
  }

  return (
    <div className={`announcement-modal-overlay ${visible ? 'visible' : ''}`}>
      <div className="announcement-modal">
        <div className="announcement-modal-header">
          <h2 className="announcement-modal-title">{announcement.title}</h2>
          <button 
            className="announcement-modal-close" 
            onClick={handleAcknowledge}
            aria-label="Close announcement"
          >
            ×
          </button>
        </div>
        
        <div className="announcement-modal-content">
          {announcement.content.split('\n').map((paragraph, index) => (
            paragraph.trim() && <p key={index}>{paragraph}</p>
          ))}
        </div>
        
        <div className="announcement-modal-footer">
          <button 
            className="btn-acknowledge" 
            onClick={handleAcknowledge}
          >
            Got it, thanks!
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;
